import cx from 'classnames';
import { sub } from 'date-fns';
import React, { useEffect, useRef, useState } from 'react';
import { Formik, Form as FormikForm, Field } from 'formik';
import useFetch from 'use-http';
import Form from '../Form/Form';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import CrossIcon from '../../../assets/icons/cross.svg?react';
import useKey from '../../hooks/useKey';
import styles from './Modal.module.scss';
import Button from '../Button';
import TextField from '../TextField/TextField';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

const Modal = ({
  children,
  visible,
  title,
  onClose,
  showClose = true,
  loading,
  popUp,
  extraButton,
  link,
  imgSize,
  popUpImg,
  isGrey,
  wide,
  fullScreen,
  customContentSizeHalf,
  disableBackdropClick = false,
}) => {
  const modalRoot = document.querySelector('body');
  const ref = useRef(null);
  const [height, setHeight] = useState(450);
  const [buttonSize, setButtonSize] = useState('medium');
  const [minusHeight, setMinusHeight] = useState(55);

  const isMobile = window.innerWidth <= 767;

  useKey('escape', loading ? undefined : onClose, visible);
  useEffect(() => {
    if (imgSize > 0) {
      // setHeight(imgSize);

      if (extraButton && extraButton.length > 40) {
        setMinusHeight(75);
      } else if (extraButton) {
        setMinusHeight(55);
      }
    }
  }, [height, extraButton, imgSize]);

  function resize() {
    var img = document.getElementById('popUpImg');
    if (img) {
      var height = img.clientHeight;
      setHeight(height);
      if (height < 350) {
        setButtonSize('small');
      } else {
        setButtonSize('medium');
      }
    }
  }

  window.onresize = resize;

  useEffect(() => {
    var img = document.getElementById('popUpImg');
    if (img != null) {
      var height = img.clientHeight;
      setHeight(height);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [document.getElementById('popUpImg')]);

  useEffect(() => {
    if (visible) {
      modalRoot.style.overflow = 'hidden';
    } else {
      modalRoot.removeAttribute('style');
    }
  }, [modalRoot, visible]);

  if (!modalRoot) {
    return null;
  }

  function getModalContent() {
    const contentClass = popUp
      ? 'modal__content-popup'
      : wide
        ? 'modal__content__wide'
        : 'modal__content';

    return (
      <CSSTransition in={visible} classNames="fade" timeout={100} unmountOnExit>
        <div className={styles['modal']}>
          <div
            className={styles['modal__container']}
            style={{
              height: fullScreen ? '100%' : 'auto',
            }}
          >
            <div
              ref={ref}
              className={styles[contentClass]}
              style={{
                height: fullScreen ? '100%' : 'auto',
                minWidth:
                  customContentSizeHalf && !isMobile
                    ? '740px'
                    : fullScreen
                      ? '100%'
                      : 'auto',
              }}
            >
              {title && !popUp && (
                <div className={styles['modal__header']}>
                  <div className={styles['modal__header__title']}>{title}</div>
                </div>
              )}

              {showClose && (
                <div
                  className={
                    isGrey
                      ? styles['modal__close-button'] +
                        ' ' +
                        styles['modal__close-button-grey']
                      : styles['modal__close-button']
                  }
                  onClick={onClose}
                >
                  <CrossIcon />
                </div>
              )}
              {popUp && (
                <div
                  style={{
                    display: 'flex',
                    position: 'relative',
                    top: height - minusHeight,
                    height: '0px',
                    justifyContent: 'end',
                    marginRight: '10px',
                  }}
                >
                  {popUp && (
                    <div
                      // className={
                      //   extraButton && link
                      //     ? styles['modal__close-blue-button']
                      //     : styles['modal__close-extra-blue-button']
                      // }
                      onClick={onClose}
                    >
                      <Button
                        size={buttonSize}
                        style={{
                          fontSize: '16px',
                        }}
                      >
                        Uždaryti
                      </Button>
                    </div>
                  )}
                  {popUp && extraButton && link && (
                    <div
                      // className={styles['modal__close-extra-blue-button']}
                      onClick={() => window.open(link)}
                    >
                      <Button
                        size={buttonSize}
                        style={{
                          fontSize: '16px',
                          marginLeft: '10px',
                        }}
                      >
                        {extraButton}
                      </Button>
                    </div>
                  )}
                </div>
              )}

              <div
                className={styles['body']}
                style={{
                  height: fullScreen ? '95%' : 'auto',
                  width: fullScreen ? '100%' : 'auto',
                }}
              >
                {children}
              </div>
            </div>
          </div>
          <div
            className={styles['modal__backdrop']}
            onClick={loading || disableBackdropClick ? undefined : onClose}
          ></div>
        </div>
      </CSSTransition>
    );
  }

  return ReactDOM.createPortal(getModalContent(), modalRoot);
};

const Actions = ({ children, alignRight = false }) => {
  return (
    <div
      className={styles['modal__actions']}
      style={alignRight ? { justifyContent: 'flex-end' } : undefined}
    >
      {children}
    </div>
  );
};

const Alert = ({ children, type = 'success', isGrey }) => {
  return (
    <div
      className={cx(styles['modal__alert'], {
        [styles['modal__alert--success']]: type === 'success',
        [styles['modal__alert--error']]: type === 'error',
        [styles['modal__alert--warning']]: type === 'warning',
        [styles['modal__text-content-grey']]: isGrey === true,
      })}
    >
      {children}
    </div>
  );
};

const TextContent = ({ children, subcontent, popUp, subtype, isGrey }) => {
  if (subcontent) {
    return (
      <div
        className={
          isGrey
            ? styles['modal__text-sub-content'] +
              ' ' +
              styles['modal__text-content-grey']
            : styles['modal__text-sub-content']
        }
      >
        {children}
      </div>
    );
  } else if (subtype === 'psdfSuccess') {
    return (
      <div className={styles['modal__text-content-psdfSuccess']}>
        {children}
      </div>
    );
  } else if (subtype === 'psdfWithAdditionalPaymentSuccess') {
    return (
      <div
        className={
          styles['modal__text-content-psdfWithAdditionalPaymentSuccess']
        }
      >
        {children}
      </div>
    );
  } else if (subtype === 'ctxrmSuccess') {
    return (
      <div className={styles['modal__text-content-ctxrmSuccess']}>
        {children}
      </div>
    );
  } else if (popUp) {
    return (
      <div className={styles['modal__text-content-popUp']}>{children}</div>
    );
  } else
    return (
      <div
        className={
          isGrey
            ? styles['modal__text-content'] +
              ' ' +
              styles['modal__text-content-grey']
            : styles['modal__text-content']
        }
      >
        {children}
      </div>
    );
};

const Edit = ({
  children,
  link,
  changeReload,
  selectedSpecialistId,
  setEditModalVisible,
  specialistFullName,
}) => {
  const { t } = useTranslation();
  const [reload, setReload] = useState(false);
  const formRef = useRef();

  const validationSchema = Yup.object().shape({
    link: Yup.string().matches(
      // /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/,
      /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/,
      'Įveskite teisingą url',
    ),
  });

  const { post: postLink, response: postLinkResponse } = useFetch(
    `/SpecialistsDescription/UrlUpdate`,
  );

  const handleLinkSubmit = async (data, { setSubmitting, setErrors }) => {
    let link = formRef.current.values.link;

    const response = await postLink('', {
      link: link,
      specialistId: selectedSpecialistId,
    });

    if (postLinkResponse.status >= 400) {
    } else if (postLinkResponse.status == 200) {
      changeReload();
      setEditModalVisible(false);
    }
  };
  return (
    <div>
      <Formik
        initialValues={{ link: link }}
        validationSchema={validationSchema}
        onSubmit={handleLinkSubmit}
        innerRef={formRef}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({ setFieldValue, errors, isSubmitting, values, setErrors }) => (
          <FormikForm>
            <Form>
              <Form.Group>
                <Form.Row>{specialistFullName}</Form.Row>
                <Form.Row>
                  <Field
                    focus={true}
                    name="link"
                    value={values.link}
                    label={t('userAccount.doctorInfo.newLink')}
                    component={TextField}
                    isGrey={true}
                  />
                </Form.Row>
                <Form.Row>
                  <Button
                    loading={isSubmitting}
                    disabled={isSubmitting}
                    size="large"
                    onClick={() => {
                      handleLinkSubmit();
                    }}
                    type="submit"
                    style={{ width: '50px' }}
                  >
                    Išsaugoti
                  </Button>
                </Form.Row>
              </Form.Group>
            </Form>
          </FormikForm>
        )}
      </Formik>
    </div>
  );
};

const EditDepartmentEmail = ({
  email,
  changeReload,
  selectedDepartmentId,
  setEditModalVisible,
  departmentTitle,
}) => {
  const { t } = useTranslation();
  const formRef = useRef();

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email('Įveskite teisingą el. pašto adresą')
      .required('El. paštas yra privalomas'),
  });

  const { post: updateDepartmentEmail, response } = useFetch(
    '/UserAccount/UpdateDepartmentEmail',
  );

  const handleSubmit = async (values, { setSubmitting }) => {
    await updateDepartmentEmail('', {
      email: values.email,
      departmentId: selectedDepartmentId,
    });

    if (response.ok) {
      changeReload();
      setEditModalVisible(false);
    }

    setSubmitting(false);
  };

  return (
    <Formik
      innerRef={formRef}
      initialValues={{ email: email || '' }}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      validateOnBlur={false}
      validateOnChange={false}
    >
      {({ isSubmitting, values }) => (
        <FormikForm>
          <Form>
            <Form.Group>
              <Form.Row>{departmentTitle}</Form.Row>

              <Form.Row>
                <Field
                  name="email"
                  value={values.email}
                  label={'El. pašto adresas'}
                  component={TextField}
                  isGrey
                />
              </Form.Row>

              <Form.Row>
                <Button
                  type="submit"
                  size="large"
                  loading={isSubmitting}
                  disabled={isSubmitting}
                  style={{ width: '120px' }}
                >
                  Išsaugoti
                </Button>
              </Form.Row>
            </Form.Group>
          </Form>
        </FormikForm>
      )}
    </Formik>
  );
};

Modal.Actions = Actions;
Modal.TextContent = TextContent;
Modal.Alert = Alert;
Modal.Edit = Edit;
Modal.EditDepartmentEmail = EditDepartmentEmail;

export default Modal;
